import { createFileRoute } from "@tanstack/react-router";
import PartsCatalogDocs from "@/pages/PartsCatalogDocs";

export const Route = createFileRoute("/parts-catalog/docs/$id")({
  head: () => ({
    meta: [
      { title: "Product Document | Rex & Sons RVs" },
      { name: "description", content: "Installation instructions and specification sheets for RV parts." },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: "Product Document | Rex & Sons RVs" },
      { property: "og:description", content: "Installation instructions and specification sheets for RV parts." },
    ],
  }),
  component: PartsCatalogDocs,
});
